import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-css-uikit',
  standalone: true,
  imports:[CommonModule],
  templateUrl: './css-uikit.component.html',
  styleUrls: ['./css-uikit.component.scss']
})
export class CssUikitComponent {
  readonly icons = [
    'kpi-analytics', 'kpi-building', 'kpi-document', 'kpi-layers',
    'kpi-briefcase', 'kpi-check-circle', 'kpi-wallet',
    'kpi-percent', 'kpi-trend-up', 'kpi-gavel', 'kpi-alert',
    'kpi-dollar', 'kpi-target', 'kpi-clock', 'kpi-clock-x',
    'kpi-file-lines', 'kpi-bell', 'kpi-lock',
  ];

  readonly paletteGroups: { group: string; items: { name: string; desc: string; isGradient?: boolean; isClass?: boolean; previewBg?: string }[] }[] = [    
    {
      group: 'Clases de background (.gio-*-bg)',
      items: [
        { name: 'gio-blue-bg',    desc: 'Blue primario', isClass: true },
        { name: 'gio-blue-bg-2',  desc: 'Blue alterno', isClass: true },
        { name: 'gio-blue-bg-3',  desc: 'Blue claro', isClass: true },
        { name: 'gio-cyan-bg',    desc: 'Cyan', isClass: true },
        { name: 'gio-green-bg',   desc: 'Green primario', isClass: true },
        { name: 'gio-green-bg-2', desc: 'Green oscuro', isClass: true },
        { name: 'gio-green-bg-3', desc: 'Green alterno', isClass: true },
        { name: 'gio-green-bg-4', desc: 'Green esmeralda', isClass: true },
        { name: 'gio-green-bg-5', desc: 'Green claro', isClass: true },
        { name: 'gio-amber-bg',   desc: 'Amber / advertencia', isClass: true },
        { name: 'gio-red-bg',     desc: 'Red / peligro', isClass: true },
        { name: 'gio-purple-bg',  desc: 'Purple', isClass: true },
        { name: 'gio-yellow-bg',  desc: 'Yellow', isClass: true },
        { name: 'gio-teal-bg',    desc: 'Teal', isClass: true },
        { name: 'gio-orange-bg',  desc: 'Orange', isClass: true },
        { name: 'gio-gray-bg',    desc: 'Gray neutro', isClass: true },
      ],
    },
    {
      group: 'Clases de texto (.gio-*-color)',
      items: [
        { name: 'gio-blue-color',    desc: 'Blue primario', isClass: true, previewBg: 'gio-blue-bg' },
        { name: 'gio-blue-color-2',  desc: 'Blue alterno', isClass: true, previewBg: 'gio-blue-bg-2' },
        { name: 'gio-blue-color-3',  desc: 'Blue claro', isClass: true, previewBg: 'gio-blue-bg-3' },
        { name: 'gio-cyan-color',    desc: 'Cyan', isClass: true, previewBg: 'gio-cyan-bg' },
        { name: 'gio-green-color',   desc: 'Green primario', isClass: true, previewBg: 'gio-green-bg' },
        { name: 'gio-green-color-2', desc: 'Green oscuro', isClass: true, previewBg: 'gio-green-bg-2' },
        { name: 'gio-green-color-3', desc: 'Green alterno', isClass: true, previewBg: 'gio-green-bg-3' },
        { name: 'gio-green-color-4', desc: 'Green esmeralda', isClass: true, previewBg: 'gio-green-bg-4' },
        { name: 'gio-green-color-5', desc: 'Green claro', isClass: true, previewBg: 'gio-green-bg-5' },
        { name: 'gio-amber-color',   desc: 'Amber / advertencia', isClass: true, previewBg: 'gio-amber-bg' },
        { name: 'gio-red-color',     desc: 'Red / peligro', isClass: true, previewBg: 'gio-red-bg' },
        { name: 'gio-purple-color',  desc: 'Purple', isClass: true, previewBg: 'gio-purple-bg' },
        { name: 'gio-yellow-color',  desc: 'Yellow', isClass: true, previewBg: 'gio-yellow-bg' },
        { name: 'gio-teal-color',    desc: 'Teal', isClass: true, previewBg: 'gio-teal-bg' },
        { name: 'gio-orange-color',  desc: 'Orange', isClass: true, previewBg: 'gio-orange-bg' },
        { name: 'gio-gray-color',    desc: 'Gray neutro', isClass: true, previewBg: 'gio-gray-bg' },
      ],
    }
  ];
}
